import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDPxjMhwfM8Zd7Lu6M_-U6qrKWj6mLhcek",
  authDomain: "zuperv2-8e691.firebaseapp.com",
  databaseURL: "https://zuperv2-8e691.firebaseio.com",
  projectId: "zuperv2-8e691",
  storageBucket: "zuperv2-8e691.firebasestorage.app",
  messagingSenderId: "613293321746",
  appId: "1:613293321746:web:621dea1dcce76c836fb2cb",
  measurementId: "G-XD46C72HH1"
};

// Initialize Firebase (SSR-safe)
let app: FirebaseApp;
let db: Firestore;

function getFirebaseApp(): FirebaseApp {
  if (!app) {
    const existingApps = getApps();
    app = existingApps.length > 0 ? existingApps[0] : initializeApp(firebaseConfig);
  }
  return app;
}

function getDb(): Firestore {
  if (!db) {
    db = getFirestore(getFirebaseApp());
  }
  return db;
}

export { getFirebaseApp, getDb };
export default getDb;
